import { render } from "./CuentasPorCobrar.vue?vue&type=template&id=a2cef34c&scoped=true"
import script from "./CuentasPorCobrar.vue?vue&type=script&lang=js"
export * from "./CuentasPorCobrar.vue?vue&type=script&lang=js"

import "./CuentasPorCobrar.vue?vue&type=style&index=0&id=a2cef34c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cef34c"]])

export default __exports__